import { Purpose } from "config/constants"
import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

export interface ICalculationDetailsRouteQueryParams {
    reservationCartId?: Guid
    reservationId?: Guid
    purpose?: Purpose
    customerName?: string
    startDate?: string
    reservationNumber?: string
    offerCalculationId?: string
    offerNumber?: string
    nodeAssetId?: string
    nodeAssetLmid?: string
    nodeAssetArticleDescription?: string
    nodeAssetArticleId?: string
}

const CalculationDetailsRoute = new AppRoute<{}, ICalculationDetailsRouteQueryParams>({
    route: "/calculation-details",
    navbar: true,
    authRequired: true,
})

export default CalculationDetailsRoute
